<template>
  <license-management></license-management>
</template>

<script>
import LicenseManagement from './LicenseManagement.vue';

export default {
  components: {
    LicenseManagement,
  },
};
</script>
